<template>

        <div class="p-0" @mouseover="showButtons" @mouseleave="hideButtons">

            <div class="position-relative">
                <div v-if="showControllers" style="width: 100%;">
                    <b-button style="position: absolute; top: 10px; right: 7px; z-index: 2;"
                              @click="removeContent" variant="outline-warning" size="sm" class="icon-button float-right">
                        <i class="simple-icon-trash"/></b-button>
                    <b-button style="position: absolute; top: 10px; right: 50px; z-index: 2;"
                              @click="editContent" variant="outline-warning" class="icon-button float-right">
                        <i class="simple-icon-pencil"/></b-button>
                    <b-button style="position: absolute; top: 10px; right: 93px; z-index: 2;"
                    @click="moveDownContent" variant="outline-warning" class="icon-button float-right">
                        <i class="simple-icon-arrow-down"/></b-button>
                    <b-button style="position: absolute; top: 10px; right: 136px; z-index: 2;"
                              @click="moveUpContent" variant="outline-warning" class="icon-button float-right">
                        <i class="simple-icon-arrow-up"/></b-button>
                </div>


                <p style="font-weight: bold" class="card-title mb-2 no-gutters" v-if="title !== null && title !== ''">
                    {{title}}</p>
                <p class="mb-2 card-title no-gutters" v-if="description !== null && description !== ''">{{description}}</p>
                <div style="width: 100%;" class="d-inline-flex no-gutters m-0 p-0">
                    <div class="no-gutters m-1 p-0" v-for="(image, index) in images" :style="{width: styleImageWidthRatio(image)+'%'}">
                        <b-img class="no-gutters m-0 p-0" fluid-grow fluid :src="image.url"></b-img>
                    </div>

                </div>


            </div>
        </div>

</template>

<script>
    export default {
        props: ['data'],
        mounted() {
            this.id = this.data.id;
            this.title = this.data.title;
            this.description = this.data.description;
            // console.log(this.data.images)
            this.images = this.data.images;
        },
        data() {
            return {
                id: "",
                displayOrder: 0,
                title: "",
                description: "",
                images: [],
                showControllers: false
            }
        },
        computed: {},
        methods: {
            widthBy1024h(image) {
                return 1024 * image.width / image.height;
            },

            totalWidthBy1024h() {
                return this.images.map(image => this.widthBy1024h(image)).reduce((pre, cur) => pre + cur);
            },

            styleImageWidthRatio(image) {
                let totalWidthBy1024h = this.totalWidthBy1024h();
                let imageWidthBy1024h = this.widthBy1024h(image);

                let widthRatio = imageWidthBy1024h / totalWidthBy1024h * 100;

                // console.log(widthRatio);
                return widthRatio;
            },

            showButtons() {
                this.showControllers = true;
            },
            hideButtons() {
                this.showControllers = false;
            },
            removeContent() {
                this.$emit('remove-sub-image-content', this.id)
            },
            editContent() {
                this.$emit('edit-sub-image-content', this.id)
            },
            moveUpContent() {
                this.$emit('move-up-sub-image-content', this.id)
            },
            moveDownContent() {
                this.$emit('move-down-sub-image-content', this.id)
            }
        },
    }
</script>

<style scoped>
    div:hover {
        background-color: #f2f2f2;
    }

    #text-hor-center {
        text-align: center;
    }

    .mainprogress div img {
        padding: 0;
        margin: 0;
        float: left;
    }
</style>
